var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-td-button-check"},[(_vm.editable && _vm.item.editable)?_c('MdtCheckbox',{staticClass:"checkbox",model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}):(_vm.value)?_c('MdtButton',{staticClass:"check-button",attrs:{"icon":'fas fa-check'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }